import './_fonts'

import Alpine from "./alpine"
import 'swiper/css'
import '../css/app.css'

window.Alpine = Alpine

Alpine.start()
